export const IbanMask = {
  mask: 'TR99 9999 9999 9999 9999 9999 99', // Doğru uzunlukta IBAN maskesi
  maskRules: {
    '9': /[0-9]/, // Rakam girişi zorunlu
    'T': /T/, // 'T' sabit kalsın
    'R': /R/  // 'R' sabit kalsın
  },
  useMaskedValue:false,
  value: 'TR'
};
